import Cookies from 'js-cookie';

import { ACCESS_TOKEN_KEY } from '../constants';

export function cleanUpAccessToken() {
  try {
    Cookies.remove(ACCESS_TOKEN_KEY);
  } catch (e) {
    //
  }
}
